import { useId, useState } from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { leadTimeNotice } from '../data/site';

/**
 * Compact, closed-by-default disclosure for special-order lead times.
 * The wording lives in `leadTimeNotice` in data/site.ts.
 */
export function LeadTimeNotice() {
  const [open, setOpen] = useState(false);
  const panelId = useId();
  return <div data-id="element-249" data-mp="3uowrq0vcnef9">
      <button type="button" aria-expanded={open} aria-controls={panelId} onClick={() => setOpen(value => !value)} className="inline-flex min-h-[44px] items-center gap-1.5 text-[15.5px] font-semibold text-ink transition-colors duration-150 ease-out hover:text-pegasus-blue" data-id="element-250" data-mp="mbg1qnkudlmv">
        <ChevronRightIcon className={`h-4 w-4 shrink-0 text-pegasus-magenta transition-transform duration-150 ease-out motion-reduce:transition-none ${open ? 'rotate-90' : ''}`} aria-hidden="true" data-id="element-251" data-mp="hbtls6dmprad" />
        {leadTimeNotice.title}
      </button>
      <div id={panelId} hidden={!open} className="pb-2 pl-[22px]" data-id="element-252" data-mp="4k057o7at2j6">
        {leadTimeNotice.paragraphs.map(paragraph => <p key={paragraph} className="mt-1 max-w-xl text-[15.5px] leading-6 text-ink/75" data-id="element-253" data-mp="3vs4irg9lrhqf">
            {paragraph}
          </p>)}
      </div>
    </div>;
}